
import Vue from 'vue'

global['____97641B6____'] = true;
delete global['____97641B6____'];
global.__uniConfig = {"easycom":{"^u-(.*)":"@/uview-ui/components/u-$1/u-$1.vue","^x-(.*)":"@/components/xview/x-$1/x-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"preloadRule":{"pages/order/checkout":{"network":"all","packages":["pages/order"]}},"tabBar":{"backgroundColor":"#fbfbfb","color":"#999","selectedColor":"#d7092f","borderStyle":"black","list":[{"iconPath":"/static/asset/tabbar/group-0/index.png","pagePath":"pages/index","selectedIconPath":"/static/asset/tabbar/group-0/index-active.png","iconWidth":"20px","text":"首页","redDot":false,"badge":""},{"iconPath":"/static/asset/tabbar/group-0/category.png","pagePath":"pages/category","selectedIconPath":"/static/asset/tabbar/group-0/category-active.png","iconWidth":"20px","text":"品类","redDot":false,"badge":""},{"iconPath":"/static/asset/tabbar/group-0/vip.png","pagePath":"pages/member-home","selectedIconPath":"/static/asset/tabbar/group-0/vip-active.png","iconWidth":"20px","text":"会员","redDot":false,"badge":""},{"iconPath":"/static/asset/tabbar/group-0/cart.png","pagePath":"pages/cart","selectedIconPath":"/static/asset/tabbar/group-0/cart-active.png","iconWidth":"20px","text":"购物车","redDot":false,"badge":""},{"iconPath":"/static/asset/tabbar/group-0/mine.png","pagePath":"pages/mine","selectedIconPath":"/static/asset/tabbar/group-0/mine-active.png","iconWidth":"20px","text":"我的","redDot":false,"badge":""}]},"globalStyle":{"navigationStyle":"custom","backgroundTextStyle":"dark","navigationBarBackgroundColor":"#fff","navigationBarTextStyle":"black","enablePullDownRefresh":false},"cloud":true,"usingShopPlugin":true,"condition":{"current":0,"list":[{"name":"","path":"","query":""}]}};
global.__uniConfig.compilerVersion = '3.1.8';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"SZEBZ-EIBEL-XJ2PI-M3QBJ-CUTQV-KKFBS"}}};
global.__uniConfig.qqMapKey = "SZEBZ-EIBEL-XJ2PI-M3QBJ-CUTQV-KKFBS";
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/index.vue')), 'pages-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cart', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/cart.vue')), 'pages-cart'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/mine.vue')), 'pages-mine'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-category', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/category.vue')), 'pages-category'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-member-home', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/member-home.vue')), 'pages-member-home'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mini-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/mini-index.vue')), 'pages-mini-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-ad-entrance', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/ad-entrance.vue')), 'pages-ad-entrance'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-webView', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/webView.vue')), 'pages-webView'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/goods.vue')), 'pages-goods'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mini-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/mini-index/index.vue')), 'pages-mini-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/login/login.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login-mobile', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/login/login-mobile.vue')), 'pages-login-login-mobile'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-introduce-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/introduce/index.vue')), 'pages-introduce-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-introduce-details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/introduce/details/index.vue')), 'pages-introduce-details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-account-edit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/account/edit.vue')), 'pages-account-edit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-account-cancellationDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/account/cancellationDetail.vue')), 'pages-account-cancellationDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-account-bind-mobile', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/account/bind-mobile.vue')), 'pages-account-bind-mobile'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-account-privacy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/account/privacy.vue')), 'pages-account-privacy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-account-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/account/register.vue')), 'pages-account-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-account-authentication', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/account/authentication.vue')), 'pages-account-authentication'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-busy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/busy.vue')), 'pages-activity-busy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-beauty-sample-machine-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/beauty-sample-machine/index.vue')), 'pages-activity-beauty-sample-machine-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-present-upgrade-activity-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/present-upgrade-activity/index.vue')), 'pages-activity-present-upgrade-activity-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-free-login-active-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/free-login-active/index.vue')), 'pages-activity-free-login-active-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-free-login-active-match', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/free-login-active/match.vue')), 'pages-activity-free-login-active-match'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-free-login-active-confirm-order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/free-login-active/confirm-order.vue')), 'pages-activity-free-login-active-confirm-order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-seckill-special', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/seckill/special.vue')), 'pages-activity-seckill-special'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-integral-mall-good-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/integral-mall/good-detail.vue')), 'pages-activity-integral-mall-good-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-lottery-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/lottery/index.vue')), 'pages-activity-lottery-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-lottery-record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/lottery/record.vue')), 'pages-activity-lottery-record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-invite-activity-inviting-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/invite-activity/inviting-index.vue')), 'pages-activity-invite-activity-inviting-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-invite-activity-inviting-invitee', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/invite-activity/inviting-invitee.vue')), 'pages-activity-invite-activity-inviting-invitee'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-invite-activity-inviting-records', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/invite-activity/inviting-records.vue')), 'pages-activity-invite-activity-inviting-records'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-check-in', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/check-in.vue')), 'pages-activity-check-in'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-check-in-center-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/check-in-center/index.vue')), 'pages-activity-check-in-center-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-integral-mall-record-details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/integral-mall/record-details.vue')), 'pages-activity-integral-mall-record-details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-integral-mall-record-checkout', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/integral-mall/record-checkout.vue')), 'pages-activity-integral-mall-record-checkout'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-points-spike-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/points-spike/index.vue')), 'pages-activity-points-spike-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-match-goods-list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/match-goods/list/index.vue')), 'pages-activity-match-goods-list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-free-trial-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/free-trial/index.vue')), 'pages-activity-free-trial-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-free-trial-invitee', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/free-trial/invitee.vue')), 'pages-activity-free-trial-invitee'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-mystery-box-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/mystery-box/index.vue')), 'pages-activity-mystery-box-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-one-plus-one-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/one-plus-one/index.vue')), 'pages-activity-one-plus-one-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-mystery-box-taskList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/mystery-box/taskList.vue')), 'pages-activity-mystery-box-taskList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-collective-groupon-goods-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/collective/groupon-goods-detail.vue')), 'pages-activity-collective-groupon-goods-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-collective-groupon-order-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/collective/groupon-order-detail.vue')), 'pages-activity-collective-groupon-order-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-collective-groupon-participate', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/collective/groupon-participate.vue')), 'pages-activity-collective-groupon-participate'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-groupon-group-order-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/groupon/group-order-list.vue')), 'pages-activity-groupon-group-order-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-groupon-group-order-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/groupon/group-order-detail.vue')), 'pages-activity-groupon-group-order-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-mask-card-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/mask-card/index.vue')), 'pages-activity-mask-card-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-mask-card-goods-exchange-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/mask-card/goods-exchange/index.vue')), 'pages-activity-mask-card-goods-exchange-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-mask-card-goods-exchange-checkout', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/mask-card/goods-exchange/checkout.vue')), 'pages-activity-mask-card-goods-exchange-checkout'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-surprise-box-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/surprise-box/index.vue')), 'pages-activity-surprise-box-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-surprise-box-lottery-record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity/surprise-box/lottery-record.vue')), 'pages-activity-surprise-box-lottery-record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-good-activity-good-list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/activity-good/activity-good-list/index.vue')), 'pages-activity-good-activity-good-list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/index.vue')), 'pages-share-officer-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-applay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/applay.vue')), 'pages-share-officer-applay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-wait', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/wait.vue')), 'pages-share-officer-wait'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-check-result', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/check-result.vue')), 'pages-share-officer-check-result'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-share-theme', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/share-theme.vue')), 'pages-share-officer-share-theme'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-my-promotion', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/my-promotion.vue')), 'pages-share-officer-my-promotion'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-certification', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/certification.vue')), 'pages-share-officer-certification'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-submit-material', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/submit-material.vue')), 'pages-share-officer-submit-material'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-account-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/account-detail.vue')), 'pages-share-officer-account-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/order.vue')), 'pages-share-officer-order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-voucher', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/voucher.vue')), 'pages-share-officer-voucher'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-share-officer-share-officer-mini-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/share-officer/share-officer-mini-index.vue')), 'pages-share-officer-share-officer-mini-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-address-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/address/list.vue')), 'pages-address-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-address-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/address/detail.vue')), 'pages-address-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cart-cart-present-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/cart/cart-present-list.vue')), 'pages-cart-cart-present-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cart-present-history-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/cart/present-history/index.vue')), 'pages-cart-present-history-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-cart-redemption-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/cart/redemption/index.vue')), 'pages-cart-redemption-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-coupon-detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/coupon-detail/index.vue')), 'pages-coupon-detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-coupon-get-wx-coupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/coupon/get-wx-coupon/index.vue')), 'pages-coupon-get-wx-coupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-brand-goods-best-sell', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/brand-goods/best-sell.vue')), 'pages-brand-goods-best-sell'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-brand-goods-brand-pavilion', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/brand-goods/brand-pavilion.vue')), 'pages-brand-goods-brand-pavilion'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/goods/goods.vue')), 'pages-goods-goods'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-coupon-my-coupon', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/goods/coupon/my-coupon.vue')), 'pages-goods-coupon-my-coupon'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-coupon-disabled-coupon', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/goods/coupon/disabled-coupon.vue')), 'pages-goods-coupon-disabled-coupon'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-coupon-choose-coupon', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/goods/coupon/choose-coupon.vue')), 'pages-goods-coupon-choose-coupon'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-coupon-coupon-wx-disabled', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/goods/coupon/coupon-wx-disabled.vue')), 'pages-goods-coupon-coupon-wx-disabled'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-all-comments', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/goods/all-comments.vue')), 'pages-goods-all-comments'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-member-contract', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/member/contract.vue')), 'pages-member-contract'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-member-account-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/member/account/index.vue')), 'pages-member-account-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-member-account-detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/member/account-detail/index.vue')), 'pages-member-account-detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-member-account-exchange-record-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/member/account-exchange-record/index.vue')), 'pages-member-account-exchange-record-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-member-gift-records-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/member/gift-records/index.vue')), 'pages-member-gift-records-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-checkout', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/order/checkout.vue')), 'pages-order-checkout'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-pay-result', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/order/pay-result.vue')), 'pages-order-pay-result'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/order/list.vue')), 'pages-order-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/order/detail.vue')), 'pages-order-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-comments', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/order/comments.vue')), 'pages-order-comments'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-delivery', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/order/delivery.vue')), 'pages-order-delivery'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-delivery-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/order/delivery-list.vue')), 'pages-order-delivery-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-modify-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/order/modify-address.vue')), 'pages-order-modify-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-redeem-mobile-redeem', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/redeem/mobile-redeem.vue')), 'pages-redeem-mobile-redeem'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-redeem-code-redeem', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/redeem/code-redeem.vue')), 'pages-redeem-code-redeem'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-redeem-credit-redeem-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/redeem/credit-redeem/index.vue')), 'pages-redeem-credit-redeem-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-redeem-upgrade-mobile-redeem', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/redeem-upgrade/mobile-redeem.vue')), 'pages-redeem-upgrade-mobile-redeem'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-redeem-upgrade-code-redeem-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/redeem-upgrade/code-redeem-index.vue')), 'pages-redeem-upgrade-code-redeem-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-redeem-upgrade-code-redeem', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/redeem-upgrade/code-redeem.vue')), 'pages-redeem-upgrade-code-redeem'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-refund-refund-type-selection', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/refund/refund-type-selection.vue')), 'pages-refund-refund-type-selection'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-refund-refund-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/refund/refund-list.vue')), 'pages-refund-refund-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-refund-refund-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/refund/refund-detail.vue')), 'pages-refund-refund-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-refund-logistics-form', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/refund/logistics-form.vue')), 'pages-refund-logistics-form'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-refund-apply-refund', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/refund/apply-refund.vue')), 'pages-refund-apply-refund'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-skin-test-coupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/skin-test-coupon/index.vue')), 'pages-skin-test-coupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-skin-test-coupon-test-coupon', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/skin-test-coupon/test-coupon.vue')), 'pages-skin-test-coupon-test-coupon'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-skin-test-coupon-skin-file', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/skin-test-coupon/skin-file.vue')), 'pages-skin-test-coupon-skin-file'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-skin-test-coupon-recommend', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/skin-test-coupon/recommend.vue')), 'pages-skin-test-coupon-recommend'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-skin-test-coupon-plan', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/skin-test-coupon/plan.vue')), 'pages-skin-test-coupon-plan'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-search-search-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/search/search-index.vue')), 'pages-search-search-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-search-category-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/search/category-list.vue')), 'pages-search-category-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-system-version', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/system/version.vue')), 'pages-system-version'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-system-user-contract', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/system/user-contract.vue')), 'pages-system-user-contract'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-channel-channel-code', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/channel/channel-code.vue')), 'pages-channel-channel-code'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-setting-privacy-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/setting/privacy/index.vue')), 'pages-setting-privacy-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-setting-privacy-channel-message', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require('/app/jenkins/workspace/sycz-web-soyoung-uniapp-h5/src/pages/setting/privacy/channel-message.vue')), 'pages-setting-privacy-channel-message'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"transparentTitle":"always","titlePenetrate":"YES","onReachBottomDistance":300})
      },
      [
        createElement('pages-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:44
}
},
{
path: '/pages/cart',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"购物车"})
      },
      [
        createElement('pages-cart', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-cart',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cart',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/pages/mine',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:4
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":"个人中心"})
      },
      [
        createElement('pages-mine', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-mine',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine',
isQuit:true,
isTabBar:true,
tabBarIndex:4,
  windowTop:0
}
},
{
path: '/pages/category',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationStyle":"custom","mp-alipay":{"transparentTitle":"always","titlePenetrate":"YES"}})
      },
      [
        createElement('pages-category', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-category',
  isNVue:false,maxWidth:0,
  pagePath:'pages/category',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/member-home',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#292A2D","transparentTitle":"always","titlePenetrate":"YES","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-member-home', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:5,
  name:'pages-member-home',
  isNVue:false,maxWidth:0,
  pagePath:'pages/member-home',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:44
}
},
{
path: '/pages/mini-index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true})
      },
      [
        createElement('pages-mini-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mini-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mini-index',
  windowTop:0
}
},
{
path: '/pages/ad-entrance',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"正在跳转..."})
      },
      [
        createElement('pages-ad-entrance', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-ad-entrance',
  isNVue:false,maxWidth:0,
  pagePath:'pages/ad-entrance',
  windowTop:0
}
},
{
path: '/pages/webView',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-webView', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-webView',
  isNVue:false,maxWidth:0,
  pagePath:'pages/webView',
  windowTop:0
}
},
{
path: '/pages/goods',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情"})
      },
      [
        createElement('pages-goods', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods',
  windowTop:0
}
},
{
path: '/pages/mini-index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"微页面","mp-weixin":{"usingComponents":{"lottery":"plugin://merc-plugin/lottery","cell":"plugin://materialPlugin/cell"}}})
      },
      [
        createElement('pages-mini-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mini-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mini-index/index',
  windowTop:0
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:0
}
},
{
path: '/pages/login/login-mobile',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-login-login-mobile', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login-mobile',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login-mobile',
  windowTop:0
}
},
{
path: '/pages/introduce/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"关于我们"})
      },
      [
        createElement('pages-introduce-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-introduce-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/introduce/index',
  windowTop:0
}
},
{
path: '/pages/introduce/details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"关于我们"})
      },
      [
        createElement('pages-introduce-details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-introduce-details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/introduce/details/index',
  windowTop:0
}
},
{
path: '/pages/account/edit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑个人资料"})
      },
      [
        createElement('pages-account-edit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-account-edit',
  isNVue:false,maxWidth:0,
  pagePath:'pages/account/edit',
  windowTop:0
}
},
{
path: '/pages/account/cancellationDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注销账号"})
      },
      [
        createElement('pages-account-cancellationDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-account-cancellationDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/account/cancellationDetail',
  windowTop:0
}
},
{
path: '/pages/account/bind-mobile',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定手机"})
      },
      [
        createElement('pages-account-bind-mobile', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-account-bind-mobile',
  isNVue:false,maxWidth:0,
  pagePath:'pages/account/bind-mobile',
  windowTop:0
}
},
{
path: '/pages/account/privacy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"隐私协议"})
      },
      [
        createElement('pages-account-privacy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-account-privacy',
  isNVue:false,maxWidth:0,
  pagePath:'pages/account/privacy',
  windowTop:0
}
},
{
path: '/pages/account/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册协议"})
      },
      [
        createElement('pages-account-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-account-register',
  isNVue:false,maxWidth:0,
  pagePath:'pages/account/register',
  windowTop:0
}
},
{
path: '/pages/account/authentication',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"身份验证"})
      },
      [
        createElement('pages-account-authentication', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-account-authentication',
  isNVue:false,maxWidth:0,
  pagePath:'pages/account/authentication',
  windowTop:0
}
},
{
path: '/pages/activity/busy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"温馨提示"})
      },
      [
        createElement('pages-activity-busy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-busy',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/busy',
  windowTop:0
}
},
{
path: '/pages/activity/beauty-sample-machine/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"水羊"})
      },
      [
        createElement('pages-activity-beauty-sample-machine-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-beauty-sample-machine-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/beauty-sample-machine/index',
  windowTop:0
}
},
{
path: '/pages/activity/present-upgrade-activity/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"礼包限时升级"})
      },
      [
        createElement('pages-activity-present-upgrade-activity-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-present-upgrade-activity-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/present-upgrade-activity/index',
  windowTop:0
}
},
{
path: '/pages/activity/free-login-active/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"免登录领奖"})
      },
      [
        createElement('pages-activity-free-login-active-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-free-login-active-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/free-login-active/index',
  windowTop:0
}
},
{
path: '/pages/activity/free-login-active/match',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"免登录领奖礼品配置"})
      },
      [
        createElement('pages-activity-free-login-active-match', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-free-login-active-match',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/free-login-active/match',
  windowTop:0
}
},
{
path: '/pages/activity/free-login-active/confirm-order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"免登录领奖确认订单"})
      },
      [
        createElement('pages-activity-free-login-active-confirm-order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-free-login-active-confirm-order',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/free-login-active/confirm-order',
  windowTop:0
}
},
{
path: '/pages/activity/seckill/special',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"活动推广页"})
      },
      [
        createElement('pages-activity-seckill-special', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-seckill-special',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/seckill/special',
  windowTop:0
}
},
{
path: '/pages/activity/integral-mall/good-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"权益详情"})
      },
      [
        createElement('pages-activity-integral-mall-good-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-integral-mall-good-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/integral-mall/good-detail',
  windowTop:0
}
},
{
path: '/pages/activity/lottery/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"店铺抽奖"})
      },
      [
        createElement('pages-activity-lottery-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-lottery-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/lottery/index',
  windowTop:0
}
},
{
path: '/pages/activity/lottery/record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"中奖纪录"})
      },
      [
        createElement('pages-activity-lottery-record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-lottery-record',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/lottery/record',
  windowTop:0
}
},
{
path: '/pages/activity/invite-activity/inviting-index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"邀请有礼"})
      },
      [
        createElement('pages-activity-invite-activity-inviting-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-invite-activity-inviting-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/invite-activity/inviting-index',
  windowTop:0
}
},
{
path: '/pages/activity/invite-activity/inviting-invitee',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"邀请有礼"})
      },
      [
        createElement('pages-activity-invite-activity-inviting-invitee', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-invite-activity-inviting-invitee',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/invite-activity/inviting-invitee',
  windowTop:0
}
},
{
path: '/pages/activity/invite-activity/inviting-records',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"邀请有礼"})
      },
      [
        createElement('pages-activity-invite-activity-inviting-records', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-invite-activity-inviting-records',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/invite-activity/inviting-records',
  windowTop:0
}
},
{
path: '/pages/activity/check-in',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"签到有礼"})
      },
      [
        createElement('pages-activity-check-in', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-check-in',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/check-in',
  windowTop:0
}
},
{
path: '/pages/activity/check-in-center/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"签到活动"})
      },
      [
        createElement('pages-activity-check-in-center-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-check-in-center-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/check-in-center/index',
  windowTop:0
}
},
{
path: '/pages/activity/integral-mall/record-details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"记录详情"})
      },
      [
        createElement('pages-activity-integral-mall-record-details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-integral-mall-record-details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/integral-mall/record-details',
  windowTop:0
}
},
{
path: '/pages/activity/integral-mall/record-checkout',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单"})
      },
      [
        createElement('pages-activity-integral-mall-record-checkout', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-integral-mall-record-checkout',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/integral-mall/record-checkout',
  windowTop:0
}
},
{
path: '/pages/activity/points-spike/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"限时秒杀"})
      },
      [
        createElement('pages-activity-points-spike-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-points-spike-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/points-spike/index',
  windowTop:0
}
},
{
path: '/pages/activity/match-goods/list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"凑单列表"})
      },
      [
        createElement('pages-activity-match-goods-list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-match-goods-list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/match-goods/list/index',
  windowTop:0
}
},
{
path: '/pages/activity/free-trial/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"免费试用"})
      },
      [
        createElement('pages-activity-free-trial-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-free-trial-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/free-trial/index',
  windowTop:0
}
},
{
path: '/pages/activity/free-trial/invitee',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activity-free-trial-invitee', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-free-trial-invitee',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/free-trial/invitee',
  windowTop:0
}
},
{
path: '/pages/activity/mystery-box/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"水羊盲盒"})
      },
      [
        createElement('pages-activity-mystery-box-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-mystery-box-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/mystery-box/index',
  windowTop:0
}
},
{
path: '/pages/activity/one-plus-one/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"1+1"})
      },
      [
        createElement('pages-activity-one-plus-one-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-one-plus-one-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/one-plus-one/index',
  windowTop:0
}
},
{
path: '/pages/activity/mystery-box/taskList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"任务列表","navigationStyle":"custom"})
      },
      [
        createElement('pages-activity-mystery-box-taskList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-mystery-box-taskList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/mystery-box/taskList',
  windowTop:0
}
},
{
path: '/pages/activity/collective/groupon-goods-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"团购商品详情"})
      },
      [
        createElement('pages-activity-collective-groupon-goods-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-collective-groupon-goods-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/collective/groupon-goods-detail',
  windowTop:0
}
},
{
path: '/pages/activity/collective/groupon-order-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"团购订单详情"})
      },
      [
        createElement('pages-activity-collective-groupon-order-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-collective-groupon-order-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/collective/groupon-order-detail',
  windowTop:0
}
},
{
path: '/pages/activity/collective/groupon-participate',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"多人拼团","enablePullDownRefresh":true})
      },
      [
        createElement('pages-activity-collective-groupon-participate', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-collective-groupon-participate',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/collective/groupon-participate',
  windowTop:0
}
},
{
path: '/pages/activity/groupon/group-order-list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"团购订单列表","enablePullDownRefresh":true})
      },
      [
        createElement('pages-activity-groupon-group-order-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-groupon-group-order-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/groupon/group-order-list',
  windowTop:0
}
},
{
path: '/pages/activity/groupon/group-order-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-activity-groupon-group-order-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-groupon-group-order-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/groupon/group-order-detail',
  windowTop:0
}
},
{
path: '/pages/activity/mask-card/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"面膜卡"})
      },
      [
        createElement('pages-activity-mask-card-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-mask-card-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/mask-card/index',
  windowTop:0
}
},
{
path: '/pages/activity/mask-card/goods-exchange/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择兑换商品"})
      },
      [
        createElement('pages-activity-mask-card-goods-exchange-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-mask-card-goods-exchange-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/mask-card/goods-exchange/index',
  windowTop:0
}
},
{
path: '/pages/activity/mask-card/goods-exchange/checkout',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单"})
      },
      [
        createElement('pages-activity-mask-card-goods-exchange-checkout', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-mask-card-goods-exchange-checkout',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/mask-card/goods-exchange/checkout',
  windowTop:0
}
},
{
path: '/pages/activity/surprise-box/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"惊喜盒子","enablePullDownRefresh":false,"mp-alipay":{"transparentTitle":"always","titleBarColor":"#000000"}})
      },
      [
        createElement('pages-activity-surprise-box-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-surprise-box-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/surprise-box/index',
  windowTop:0
}
},
{
path: '/pages/activity/surprise-box/lottery-record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"惊喜盒子","enablePullDownRefresh":false})
      },
      [
        createElement('pages-activity-surprise-box-lottery-record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-surprise-box-lottery-record',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/surprise-box/lottery-record',
  windowTop:0
}
},
{
path: '/pages/activity-good/activity-good-list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"活动列表"})
      },
      [
        createElement('pages-activity-good-activity-good-list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-good-activity-good-list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity-good/activity-good-list/index',
  windowTop:0
}
},
{
path: '/pages/share-officer/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-share-officer-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/index',
  windowTop:0
}
},
{
path: '/pages/share-officer/applay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-share-officer-applay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-applay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/applay',
  windowTop:0
}
},
{
path: '/pages/share-officer/wait',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-share-officer-wait', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-wait',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/wait',
  windowTop:0
}
},
{
path: '/pages/share-officer/check-result',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"审核结果"})
      },
      [
        createElement('pages-share-officer-check-result', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-check-result',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/check-result',
  windowTop:0
}
},
{
path: '/pages/share-officer/share-theme',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择主题"})
      },
      [
        createElement('pages-share-officer-share-theme', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-share-theme',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/share-theme',
  windowTop:0
}
},
{
path: '/pages/share-officer/my-promotion',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的推广"})
      },
      [
        createElement('pages-share-officer-my-promotion', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-my-promotion',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/my-promotion',
  windowTop:0
}
},
{
path: '/pages/share-officer/certification',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"实名认证"})
      },
      [
        createElement('pages-share-officer-certification', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-certification',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/certification',
  windowTop:0
}
},
{
path: '/pages/share-officer/submit-material',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-share-officer-submit-material', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-submit-material',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/submit-material',
  windowTop:0
}
},
{
path: '/pages/share-officer/account-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"结算明细"})
      },
      [
        createElement('pages-share-officer-account-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-account-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/account-detail',
  windowTop:0
}
},
{
path: '/pages/share-officer/order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的推广订单"})
      },
      [
        createElement('pages-share-officer-order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-order',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/order',
  windowTop:0
}
},
{
path: '/pages/share-officer/voucher',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"结算凭证"})
      },
      [
        createElement('pages-share-officer-voucher', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-voucher',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/voucher',
  windowTop:0
}
},
{
path: '/pages/share-officer/share-officer-mini-index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"粉丝专属"})
      },
      [
        createElement('pages-share-officer-share-officer-mini-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-share-officer-share-officer-mini-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/share-officer/share-officer-mini-index',
  windowTop:0
}
},
{
path: '/pages/address/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收货地址列表"})
      },
      [
        createElement('pages-address-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-address-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/address/list',
  windowTop:0
}
},
{
path: '/pages/address/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收货地址"})
      },
      [
        createElement('pages-address-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-address-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/address/detail',
  windowTop:0
}
},
{
path: '/pages/cart/cart-present-list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"礼包"})
      },
      [
        createElement('pages-cart-cart-present-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-cart-cart-present-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cart/cart-present-list',
  windowTop:0
}
},
{
path: '/pages/cart/present-history/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"历史礼包"})
      },
      [
        createElement('pages-cart-present-history-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-cart-present-history-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cart/present-history/index',
  windowTop:0
}
},
{
path: '/pages/cart/redemption/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"凑单享超值换购"})
      },
      [
        createElement('pages-cart-redemption-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-cart-redemption-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/cart/redemption/index',
  windowTop:0
}
},
{
path: '/pages/coupon-detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"优惠券"})
      },
      [
        createElement('pages-coupon-detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-coupon-detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/coupon-detail/index',
  windowTop:0
}
},
{
path: '/pages/coupon/get-wx-coupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"优惠券"})
      },
      [
        createElement('pages-coupon-get-wx-coupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-coupon-get-wx-coupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/coupon/get-wx-coupon/index',
  windowTop:0
}
},
{
path: '/pages/brand-goods/best-sell',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"热销榜"})
      },
      [
        createElement('pages-brand-goods-best-sell', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-brand-goods-best-sell',
  isNVue:false,maxWidth:0,
  pagePath:'pages/brand-goods/best-sell',
  windowTop:0
}
},
{
path: '/pages/brand-goods/brand-pavilion',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"品牌馆"})
      },
      [
        createElement('pages-brand-goods-brand-pavilion', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-brand-goods-brand-pavilion',
  isNVue:false,maxWidth:0,
  pagePath:'pages/brand-goods/brand-pavilion',
  windowTop:0
}
},
{
path: '/pages/goods/goods',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情","mp-alipay":{"usingComponents":{"member-open":"plugin://memberPlugin/member-open"}}})
      },
      [
        createElement('pages-goods-goods', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods',
  windowTop:0
}
},
{
path: '/pages/goods/coupon/my-coupon',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的卡券"})
      },
      [
        createElement('pages-goods-coupon-my-coupon', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-coupon-my-coupon',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/coupon/my-coupon',
  windowTop:0
}
},
{
path: '/pages/goods/coupon/disabled-coupon',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"历史记录"})
      },
      [
        createElement('pages-goods-coupon-disabled-coupon', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-coupon-disabled-coupon',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/coupon/disabled-coupon',
  windowTop:0
}
},
{
path: '/pages/goods/coupon/choose-coupon',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"优惠券"})
      },
      [
        createElement('pages-goods-coupon-choose-coupon', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-coupon-choose-coupon',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/coupon/choose-coupon',
  windowTop:0
}
},
{
path: '/pages/goods/coupon/coupon-wx-disabled',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"历史卡券"})
      },
      [
        createElement('pages-goods-coupon-coupon-wx-disabled', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-coupon-coupon-wx-disabled',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/coupon/coupon-wx-disabled',
  windowTop:0
}
},
{
path: '/pages/goods/all-comments',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品评价","enablePullDownRefresh":true})
      },
      [
        createElement('pages-goods-all-comments', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-all-comments',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/all-comments',
  windowTop:0
}
},
{
path: '/pages/member/contract',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"协议"})
      },
      [
        createElement('pages-member-contract', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-member-contract',
  isNVue:false,maxWidth:0,
  pagePath:'pages/member/contract',
  windowTop:0
}
},
{
path: '/pages/member/account/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的水羊币"})
      },
      [
        createElement('pages-member-account-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-member-account-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/member/account/index',
  windowTop:0
}
},
{
path: '/pages/member/account-detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"水羊币明细"})
      },
      [
        createElement('pages-member-account-detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-member-account-detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/member/account-detail/index',
  windowTop:0
}
},
{
path: '/pages/member/account-exchange-record/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换记录"})
      },
      [
        createElement('pages-member-account-exchange-record-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-member-account-exchange-record-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/member/account-exchange-record/index',
  windowTop:0
}
},
{
path: '/pages/member/gift-records/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"礼包"})
      },
      [
        createElement('pages-member-gift-records-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-member-gift-records-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/member/gift-records/index',
  windowTop:0
}
},
{
path: '/pages/order/checkout',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"确认订单","mp-alipay":{"usingComponents":{"trade-pay":"plugin://tradePay/index","trade-placeholder":"/components/trade-placeholder/index"},"componentPlaceholder":{"trade-pay":"trade-placeholder"}}})
      },
      [
        createElement('pages-order-checkout', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-checkout',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/checkout',
  windowTop:0
}
},
{
path: '/pages/order/pay-result',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付结果"})
      },
      [
        createElement('pages-order-pay-result', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-pay-result',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/pay-result',
  windowTop:0
}
},
{
path: '/pages/order/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单列表","mp-alipay":{"usingComponents":{"trade-pay":"plugin://tradePay/index","trade-placeholder":"/components/trade-placeholder/index"},"componentPlaceholder":{"trade-pay":"trade-placeholder"}}})
      },
      [
        createElement('pages-order-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/list',
  windowTop:0
}
},
{
path: '/pages/order/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情","mp-alipay":{"usingComponents":{"trade-pay":"plugin://tradePay/index","trade-placeholder":"/components/trade-placeholder/index"},"componentPlaceholder":{"trade-pay":"trade-placeholder"}}})
      },
      [
        createElement('pages-order-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/detail',
  windowTop:0
}
},
{
path: '/pages/order/comments',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"评价订单"})
      },
      [
        createElement('pages-order-comments', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-comments',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/comments',
  windowTop:0
}
},
{
path: '/pages/order/delivery',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"查看物流"})
      },
      [
        createElement('pages-order-delivery', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-delivery',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/delivery',
  windowTop:0
}
},
{
path: '/pages/order/delivery-list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表"})
      },
      [
        createElement('pages-order-delivery-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-delivery-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/delivery-list',
  windowTop:0
}
},
{
path: '/pages/order/modify-address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改地址"})
      },
      [
        createElement('pages-order-modify-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-modify-address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/modify-address',
  windowTop:0
}
},
{
path: '/pages/redeem/mobile-redeem',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"手机号领奖"})
      },
      [
        createElement('pages-redeem-mobile-redeem', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-redeem-mobile-redeem',
  isNVue:false,maxWidth:0,
  pagePath:'pages/redeem/mobile-redeem',
  windowTop:0
}
},
{
path: '/pages/redeem/code-redeem',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换码领奖"})
      },
      [
        createElement('pages-redeem-code-redeem', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-redeem-code-redeem',
  isNVue:false,maxWidth:0,
  pagePath:'pages/redeem/code-redeem',
  windowTop:0
}
},
{
path: '/pages/redeem/credit-redeem/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消费金额兑水羊币"})
      },
      [
        createElement('pages-redeem-credit-redeem-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-redeem-credit-redeem-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/redeem/credit-redeem/index',
  windowTop:0
}
},
{
path: '/pages/redeem-upgrade/mobile-redeem',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"手机号领奖","mp-alipay":{"usingComponents":{"member-open":"plugin://memberPlugin/member-open"}}})
      },
      [
        createElement('pages-redeem-upgrade-mobile-redeem', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-redeem-upgrade-mobile-redeem',
  isNVue:false,maxWidth:0,
  pagePath:'pages/redeem-upgrade/mobile-redeem',
  windowTop:0
}
},
{
path: '/pages/redeem-upgrade/code-redeem-index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换码领奖"})
      },
      [
        createElement('pages-redeem-upgrade-code-redeem-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-redeem-upgrade-code-redeem-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/redeem-upgrade/code-redeem-index',
  windowTop:0
}
},
{
path: '/pages/redeem-upgrade/code-redeem',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换码领奖"})
      },
      [
        createElement('pages-redeem-upgrade-code-redeem', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-redeem-upgrade-code-redeem',
  isNVue:false,maxWidth:0,
  pagePath:'pages/redeem-upgrade/code-redeem',
  windowTop:0
}
},
{
path: '/pages/refund/refund-type-selection',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择退款类型"})
      },
      [
        createElement('pages-refund-refund-type-selection', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-refund-refund-type-selection',
  isNVue:false,maxWidth:0,
  pagePath:'pages/refund/refund-type-selection',
  windowTop:0
}
},
{
path: '/pages/refund/refund-list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退款列表"})
      },
      [
        createElement('pages-refund-refund-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-refund-refund-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/refund/refund-list',
  windowTop:0
}
},
{
path: '/pages/refund/refund-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退款详情"})
      },
      [
        createElement('pages-refund-refund-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-refund-refund-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/refund/refund-detail',
  windowTop:0
}
},
{
path: '/pages/refund/logistics-form',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"填写物流信息"})
      },
      [
        createElement('pages-refund-logistics-form', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-refund-logistics-form',
  isNVue:false,maxWidth:0,
  pagePath:'pages/refund/logistics-form',
  windowTop:0
}
},
{
path: '/pages/refund/apply-refund',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请退款"})
      },
      [
        createElement('pages-refund-apply-refund', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-refund-apply-refund',
  isNVue:false,maxWidth:0,
  pagePath:'pages/refund/apply-refund',
  windowTop:0
}
},
{
path: '/pages/skin-test-coupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-skin-test-coupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-skin-test-coupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/skin-test-coupon/index',
  windowTop:0
}
},
{
path: '/pages/skin-test-coupon/test-coupon',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-skin-test-coupon-test-coupon', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-skin-test-coupon-test-coupon',
  isNVue:false,maxWidth:0,
  pagePath:'pages/skin-test-coupon/test-coupon',
  windowTop:0
}
},
{
path: '/pages/skin-test-coupon/skin-file',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-skin-test-coupon-skin-file', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-skin-test-coupon-skin-file',
  isNVue:false,maxWidth:0,
  pagePath:'pages/skin-test-coupon/skin-file',
  windowTop:0
}
},
{
path: '/pages/skin-test-coupon/recommend',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-skin-test-coupon-recommend', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-skin-test-coupon-recommend',
  isNVue:false,maxWidth:0,
  pagePath:'pages/skin-test-coupon/recommend',
  windowTop:0
}
},
{
path: '/pages/skin-test-coupon/plan',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-skin-test-coupon-plan', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-skin-test-coupon-plan',
  isNVue:false,maxWidth:0,
  pagePath:'pages/skin-test-coupon/plan',
  windowTop:0
}
},
{
path: '/pages/search/search-index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索"})
      },
      [
        createElement('pages-search-search-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-search-search-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/search/search-index',
  windowTop:0
}
},
{
path: '/pages/search/category-list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索"})
      },
      [
        createElement('pages-search-category-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-search-category-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/search/category-list',
  windowTop:0
}
},
{
path: '/pages/system/version',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"版本号"})
      },
      [
        createElement('pages-system-version', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-system-version',
  isNVue:false,maxWidth:0,
  pagePath:'pages/system/version',
  windowTop:0
}
},
{
path: '/pages/system/user-contract',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户授权协议","titleNView":{}})
      },
      [
        createElement('pages-system-user-contract', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-system-user-contract',
  isNVue:false,maxWidth:0,
  pagePath:'pages/system/user-contract',
  windowTop:0
}
},
{
path: '/pages/channel/channel-code',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"渠道活码"})
      },
      [
        createElement('pages-channel-channel-code', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-channel-channel-code',
  isNVue:false,maxWidth:0,
  pagePath:'pages/channel/channel-code',
  windowTop:0
}
},
{
path: '/pages/setting/privacy/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设置"})
      },
      [
        createElement('pages-setting-privacy-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-setting-privacy-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/setting/privacy/index',
  windowTop:0
}
},
{
path: '/pages/setting/privacy/channel-message',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"渠道信息设置"})
      },
      [
        createElement('pages-setting-privacy-channel-message', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-setting-privacy-channel-message',
  isNVue:false,maxWidth:0,
  pagePath:'pages/setting/privacy/channel-message',
  windowTop:0
}
},
{
path: '/preview-image',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-preview-image', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'preview-image',
  pagePath:'/preview-image'
}
}
    ,
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
